import { useInfiniteQuery } from '@tanstack/react-query'

import { bookmarksApi } from '@/api/endpoints'
import { keys } from '@/api/keys'
import type { Page, Post } from '@/api/types'
import { PageHeader } from '@/app/layouts/PageHeader'
import { useCurrentUser } from '@/features/auth'
import { PostList } from '@/features/posts'
import { useT } from '@/i18n'

export function BookmarksPage() {
  const t = useT()
  const { user } = useCurrentUser()
  const query = useInfiniteQuery({
    queryKey: keys.bookmarks(),
    queryFn: ({ pageParam }) => bookmarksApi.list(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last: Page<Post>) => last.next_cursor ?? undefined,
  })

  return (
    <>
      <PageHeader title={t('nav.bookmarks')} subtitle={user ? `@${user.username}` : undefined} />
      <PostList
        query={query}
        emptyTitle={t('bookmarks.emptyTitle')}
        emptyDescription={t('bookmarks.emptyBody')}
      />
    </>
  )
}
